// NOTE ceci est deprecated so on utilise le SequenceManager post-merge avec le datamanager

export const SequencesFile = window.sequences.SequencesFile
export const ElementColumns = window.sequences.utils.ElementColumns
export default window.sequences.SequencesManager.instance